import { render, staticRenderFns } from "./FraudPage.vue?vue&type=template&id=fb87bbdc&scoped=true&"
import script from "./FraudPage.vue?vue&type=script&lang=js&"
export * from "./FraudPage.vue?vue&type=script&lang=js&"
import style0 from "./FraudPage.vue?vue&type=style&index=0&id=fb87bbdc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb87bbdc",
  null
  
)

export default component.exports